module.exports = __webpack_public_path__ + "img/base.28927ff5.png";